import React from 'react';
import { AssessmentsProvider } from 'features/assessments/contexts/AssessmentsContext';
import { Assessments } from 'components/Assessments/Assessments';

export const UnauthenticatedAssessments = () => (
  <AssessmentsProvider>
    <Assessments />
  </AssessmentsProvider>
);
